export default __webpack_public_path__ + "static/media/rewardPic.af4c9685.jpg";